import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Modul, ModulUpdate } from './ghiseu-module.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GhiseuModuleService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getModulUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.getModul;
    private getModuleUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.getModule;
    private getModuleActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.getModuleActive;
    private getModulePublicUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.getModulePublic;
    private storeModulUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.storeModul;
    private updateModulUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.updateModul;
    private deleteModulUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.deleteModul;
    private changeStatusActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.changeStatusModulActive;
    private changeStatusPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.changeStatusModulPublic;
    private listProgramLocatiiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.locatiiProgram;
    private listModulSloturiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.moduleSloturi;
    private advancedEditModulUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.advancedEdit;
    private moveUpUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.moveUp;
    private moveDownUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.module.moveDown;

    constructor(private http: HttpClient) { }

    getModul(id: number) {
        return this.http.get(this.getModulUrl + id, this.httpOptions);
    }

    addModul(modul: Modul) {
        return this.http.post(this.storeModulUrl, modul, this.httpOptions);
    }

    updateModul(modul: ModulUpdate) {
        return this.http.put(this.updateModulUrl, modul, this.httpOptions);
    }

    deleteModul(id: number) {
        return this.http.delete(this.deleteModulUrl + id);
    }

    changeStatuseActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusePublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    getModule() {
        return this.http.get(this.getModuleUrl, this.httpOptions);
    }

    getModuleActive() {
        return this.http.get(this.getModuleActiveUrl, this.httpOptions);
    }

    getModulePublic() {
        return this.http.get(this.getModulePublicUrl, this.httpOptions);
    }

    listProgramLocatii(modulId: number, locatieId: number) {
        return this.http.get(this.listProgramLocatiiUrl + modulId + '/' + locatieId, this.httpOptions);
    }

    listModulSloturi(modulId: number, locatieId: number) {
        return this.http.get(this.listModulSloturiUrl + modulId + '/' + locatieId).pipe(
            map((response: any) => response.data),
            catchError((error) => {
                console.error('Error in get modul sloturi:', error);
                return throwError(error);
            })
        );
    }

    advancedEditModul(data: any) {
        return this.http.put(this.advancedEditModulUrl, data);
    }

    moveUp(id: number) {
        return this.http.put(this.moveUpUrl + id, this.httpOptions);
    }

    moveDown(id: number) {
        return this.http.put(this.moveDownUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
